import * as ko from 'knockout';
import flatpickr from 'flatpickr';
import type { BaseOptions, Plugin } from 'flatpickr/dist/types/options';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';

(() => {
    const buildOptions = (element: HTMLElement, rawOptions: any): BaseOptions => {
        const plugins: Plugin[] = [];
        if (rawOptions) {
            if (rawOptions.plugins?.length) {
                for (const plugin of rawOptions.plugins) {
                    if (plugin.hook === 'monthSelectPlugin') {
                        plugins.push(monthSelectPlugin(plugin.options));
                    }
                }
            }
            let appendTo: Element;
            if (rawOptions.appendTo) {
                appendTo = document.querySelector(rawOptions.appendTo);
            } else {
                appendTo = element.closest('body'); // Match the real body when in PB Designer
            }
            return {
                ...rawOptions,
                appendTo,
                positionElement: element.querySelector(rawOptions.positionElement),
                plugins,
            };
        }
        return null;
    };

    ko.bindingHandlers["datePicker"] = {
        init: (element: HTMLElement, valueAccessor, allBindings, viewModel, bindingContext) => {
            const model = ko.utils.unwrapObservable(valueAccessor());
            const options = buildOptions(element, model?.options);
            const fp: flatpickr.Instance = flatpickr(element, options);
            // Handle removing an element from the DOM
            ko.utils.domNodeDisposal.addDisposeCallback(element, (node: Node): void => {
               fp.destroy();
            });
        },
/*
        update: (element: HTMLElement, valueAccessor) => {
            console.log('Update flatpickr');
            const fp: flatpickr.Instance = element['_flatpickr'];
            if (fp) {
                console.log('Flatpickr instance found.');
                const model = ko.utils.unwrapObservable(valueAccessor());
                if (model?.options) {
                    const options = buildOptions(element, model.options);
                    if (options) {
                        for (const key in options) {
                            if (options.hasOwnProperty(key)) {
                                fp.set(key as keyof Options, options[key]);
                            }
                        }
                    }
                }
            } else {
                console.log('Flatpickr instance NOT found.');
            }
        }
*/
    };
})();